// extracted by mini-css-extract-plugin
export default {"preview-code":"settings_preview-code__EGczg","preview-code-input":"settings_preview-code-input__bNBRm"};